// extracted by mini-css-extract-plugin
export default {"taskIconContent":"DetailScore_taskIconContent__nSKUl","taskIconItem":"DetailScore_taskIconItem__y+4BW","small":"DetailScore_small__pS3Iy"};